module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pending_wrap"
  }, [(_vm.step) ? _c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.step
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v("Pending result")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inp1),
      expression: "inp1"
    }],
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Thank you for requesting an interview with HAWO. "), _c('br'), _vm._v("Currently there are no available times. You may check our interview availability again tomorrow, or reach out to us at\n\t\t\t\t"), _c('a', {
    attrs: {
      "href": _vm.need_mail
    }
  }, [_vm._v(_vm._s(_vm.e_mail))]), _vm._v(".")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inp2),
      expression: "inp2"
    }],
    staticClass: "letter"
  }, [_c('p', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",")]), _vm._v(" "), _c('p', [_vm._v("Please make sure to check your email or Skype for the next step/s in the process. Your recruiter will be reaching out to you via those channels.")]), _vm._v(" "), _c('p', [_vm._v("You may also add the HAWO Recruitment Skype: live:.cid.9d7dbebba05d49b9 for faster coordination.")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('ac')], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Best,"), _c('br'), _vm._v("The HAWO Recruitment Team")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49a5470a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/other/pending.vue
// module id = 841
// module chunks = 1